// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"49985e1a","236":"dd7d14f2","703":"a72e27ef","787":"88e18b04"}[chunkId] + ".chunk.js";
};